<template>
  <div>
    <Header :home="false" :logged="logged" :arealogada="true"/>
    <div
      class="text-center"
      v-if="loading"
      style="
        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: 10002;
        margin: 0;
        top: 0;
        padding-top: 20%;
      "
    >
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Text Centered"
      ></b-spinner>
      <br /><span style="color: #004e86">Processando Aguarde...</span>
    </div>
    <b-modal
        ref="cancelar_pedido"
        title="Atenção"
    >
        <p v-html="mensagem"></p>
        <p>
          <b-form-textarea
          v-model="motivo_cancelamento"
          placeholder="Digite o motivo do cancelamento"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        </p>
        <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="sm"
            class="float-left"
            @click="fechar_modal"
          >
            Cancelar Ação
          </b-button>
          <b-button
            
            variant="primary"
            size="sm"
            class="float-right"
            @click="efetua_cancelamento_pedido"
            :disabled="carregando"
          >
            Cancelar Pedido
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal ref="erro" :title="erro.titulo" @hidden="resetarMsg">
      <p>{{ this.erro.msg }}</p>
    </b-modal>
    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex" style="padding: 0;">
          <b-container fluid id="painelcontainerfluid">
            <b-row>
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb :items="breadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;" >
                <b-link class="btn-voltar" href="/painel" style="text-decoration:none;font: normal normal bold 16px/24px 'Kanit', sans-serif;color:#597EB5;">
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>
            <!-- <h1>Pedidos de anuência a títulos protestados</h1> -->
            <a
                    id="dwnldLnka"
                    download="anuencia"
                    style="display: none"
                  />
                  <a
                    id="anexo"
                    download="anexo"
                    style="display: none"
                  />
            <arealogadapesquisa @filtrarBusca="filtrarBusca" :resultado="items" :colunas="colunas" :colunasMobile="colunasMobile" :hasFilter="true" :page="'aprovadas'" :title="'Anuências Solicitadas'" @chamar-funcao="executarFuncao"/>
            <!-- <div>
              <div id="empresaCredoraCollapse" class="mt-2">
                <b-card> -->
                  <!-- formulario de pesquisar -->
             <!-- <b-form name="frmBuscarAnuencia" id="frmBuscarAnuencia">
                    <b-row>
                      <b-col cols="12" md="12" lg="12">
                        <b-form-group size="sm" label="Empresa credora">
                          <b-form-select
                            disabled
                            id="empresaCredora"
                            :options="empresaCredora"
                            v-model="empresaCredoraSelected"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <p class="card-text">Informe sua pesquisa</p>
                    <b-row>
                      <b-col cols="12" md="6" lg="4">
                        <b-form-group
                          label="Nome do Devedor:"
                          label-for="nomeDevedor"
                        >
                          <b-form-input
                            id="nomeDevedor"
                            v-model="form.nomeDevedor"
                            placeholder="Nome do Devedor"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" md="4" lg="2">
                        <b-form-group
                          label="Data de Solicitação"
                          label-for="dtSolicitacao"
                          description="Data de Solicitação da Anuência"
                        >
                          <b-form-input
                            id="dtSolicitacao"
                            v-model="form.dtSolicitacao"
                            placeholder="Data de Solicitação"
                            type="date"
                            :max="_dataMaxima"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" md="6" lg="2">
                        <b-form-group
                          label="Número do título:"
                          label-for="nrtituloDevedor"
                          descriptio="Número que identifica o título"
                        >
                          <b-form-input
                            id="nrtituloDevedor"
                            v-model="form.nrtituloDevedor"
                            placeholder="Número"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" md="6" lg="4">
                        <b-form-group
                          label="Documento do devedor"
                          label-for="docDevedor"
                        >
                          <the-mask
                            :mask="['###.###.###-##', '##.###.###/####-##']"
                            id="docDevedor"
                            v-model="form.docDevedor"
                            class="form-control"
                            placeholder="CPF ou CNPJ"
                            maxlength="18"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-button
                      @click="pesquisar"
                      id="pesquisar"
                      type="button"
                      variant="primary"
                      ><font-awesome-icon icon="search" /> Buscar</b-button
                    >
                  </b-form> -->
                <!-- </b-card>
              </div>
            </div> -->
            <!-- <div> -->
              <!-- <b-table
                id="my-table"
                small
                :items="items"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
                stacked="sm"
                striped
                hover
                responsive="sm"
              > -->
              <!-- <b-table
                id="my-table"
                small
                :items="items"
                :fields="fields"
                stacked="sm"
                striped
                hover
                responsive="sm"
              > -->
                <!-- formata o documento -->
                <!-- <template slot="selecione" slot-scope="row">
                  <template>
                    <span
                      aria-hidden="true"
                      v-if="
                        row.rowSelected == true || row.item.rowSelected == true
                      "
                      >&check;</span
                    >
                    <span aria-hidden="true" v-else>&nbsp;</span>
                  </template>
                </template>
                <template #cell(nm_nr_titulo)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.nm_nr_titulo }}
                  </a>
                </template>
                <template #cell(nm_nr_documento_devedor)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.nm_nr_documento_devedor | documento }}
                    <span>
                      {{ row.item.nm_nr_documento_devedor | documento }}
                    </span>
                  </a>
                </template>
                <template #cell(NomeCartorio)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.NomeCartorio | cidadeCartorio }}
                    <span> {{ row.item.NomeCartorio | nomeCartorio }} </span>
                  </a>
                </template>
                <template #cell(nm_devedor)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.nm_devedor | upper }}
                    <span> {{ row.item.nm_devedor }} </span>
                  </a>
                </template>
                <template #cell(dt_cadastro)="row">
                  {{ row.item.dt_cadastro | dataHora }}
                </template>
                <template #cell(vl_titulo)="row">
                  {{ row.item.vl_titulo | moeda }}
                </template>
                <template #cell(vl_protesto)="row">
                  {{ row.item.vl_protesto | moeda }}
                </template>
                <template #cell(cd_status)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.cd_status | upper }}
                    <span> {{ row.item.cd_status }} </span>
                  </a>
                </template>
                <template #cell(actions)="row">
                  <div
                    v-b-popover.hover.top="row.item.motivo_recusa"
                    title="Motivo Recusa"
                    v-if="
                      row.item.cd_status === 'Reprovado' ||
                      row.item.cd_status === 'Finalizado'
                    "
                    class="text-center"
                  >
                    <span>
                      <font-awesome-icon
                        icon="info"
                        mask="circle"
                        size="1x"
                        color="red"
                      />
                    </span>
                  </div>
                  <a
                    :id="'anexo_' + row.item.id"
                    :download="'anexo_' + row.item.nm_chave + '_' + row.item.id"
                    style="display: none"
                  />
                  <a
                    :id="'dwnldLnk' + row.item.id"
                    :download="row.item.nm_chave + '_' + row.item.id"
                    style="display: none"
                  />

                  <font-awesome-icon
                    icon="download"
                    size="1x"
                    @click="baixarPDF(row.item.id)"
                    v-if="row.item.cd_status === 'Aprovado'"
                    style="cursor: pointer"
                  />
                </template>
              </b-table> -->
              <!-- <p> -->
                <!-- <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                ></b-pagination> -->
              <!-- </p> -->
            <!-- </div> -->
            <div class="loading">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
                v-if="loading"
              ></b-spinner>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </div>
    
    <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>


<script>
// import axios from "axios"
import Header from "../../components/Header";
import API from "../../services/api";
import Menu from "../../template/Menu";
import { TheMask } from "vue-the-mask";
import arealogada from "@/components/arealogada/index.vue";
import arealogadapesquisa from "@/components/arealogada/pesquisa/index.vue";
import footersite from "@/components/footersite";
import footersitemobile from "@/components/footersite/index_mobile";

//import Modal from '../../components/modal/Confmodal'

export default {
  components: {
    Header,
    Menu,
    TheMask,
    arealogada,
    arealogadapesquisa,
    footersite,
    footersitemobile
    //Modal,
  },
  data() {
    return {
      breadCrumb:[
        {text: 'Painel',href: "/painel" },
        {text: 'Cancelamento',disabled: true},
        {text: 'Todos os Pedidos',active: true}
      ],
      mensagem: null,
      cd_pedido_atual: null,
      motivo_cancelamento:null,
      carregando : false,
      loading: true,
      perPage: 0,
      currentPage: 1,
      dismissSecs: 5,
      dismissCountDownDOC: 0,
      empresaCredoraSelected:null,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
        conteudo: "",
      },
      infoModalDeletar: {
        id: "info-modal-deletar",
        title: "",
        conteudo: "",
      },
      // filterFields:[
      //   {key:"nm_devedor",label:"Nome do devedor:",placeholder:"Nome devedor",size:"1", inputType:'',},
      //   {key:"ocorrencia",label:"Ocorrência:",placeholder:"XXXXXXXXX",size:"1", inputType:'',},
      //   {key:"nm_nr_documento_devedor",label:"Documento do devedor:",placeholder:"XXXXXXXXX",size:"1", inputType:'', mask:{cpf:'###.###.###-##', cnpj:'##.###.###/####-##'}},
      //   {key:"numero",label:"Número:",placeholder:"Nº documento",size:"1", inputType:'',},
      //   {key:"nosso_numero",label:"Nosso número:",placeholder:"XXXXXXXXX",size:"1", inputType:'',},
      //   {key:"dt_emissao",label:"Data emissão:",placeholder:"DD/MM/AAAA",size:"1", inputType:'',},
      //   {key:"dt_vencimento",label:"Data vencimento:",placeholder:"DD/MM/AAAA",size:"1", inputType:'',},
      //   {key:"vl_titulo",label:"Valor do título:",placeholder:"R$",size:"1", isCurrency:true, inputType:'',},
      //   {key:"vl_protesto",label:"Valor a protestar:",placeholder:"R$",size:"1", isCurrency:true, inputType:'',},
      // ],
      colunas: [
        { key: "cd_anuencia", label: "Nº Anuência", sortable: false, size:'1.5fr' },
        { key: "nm_nr_titulo", label: "Nº Título", sortable: true, size:'0.5fr' },
        // { key: "sg_especie", label: "Espécie", sortable: true, size:'0.5fr' },
        { key: "nm_devedor", label: "Devedor", sortable: true, size:'2fr' },
        // { key: "NomeCartorio", label: "Cartório", sortable: true, size:'2fr' },
        { key: "documento_devedor", label: "Documento", sortable: true, size:'2fr', maskDoc: true },
        { key: "dt_cadastro", label: "Data de cadastro", sortable: true, size:'1.5fr',isDate:true},
        { key: "vl_titulo", label: "Valor Título", sortable: true, size:'1.5fr', isCurrency:true },
        { key: "vl_protesto", label: "Valor Protestado", sortable: true, size:'1.5fr', isCurrency:true},
        { key: "ds_status", label: "Status", sortable: true, size:'1fr' },
        { key: 'details', label: 'Exibir', sortable: false, size:'0.5fr'},
        { key: "actions", label: "Ação", sortable: false, size:"0.5fr", acoes: [
            {icone: 'download', tamanho: '1x', titulo: 'Download Anuncia', cor: 'text-info', condicao: true, funcao: 'baixarPDF'},
            {icone: 'trash', tamanho: '1x', titulo: 'Cancelar Pedido', cor: 'text-danger', condicao: 'ic_cancela_pedido', funcao: 'cancelar_pedido'}

        ]}
      ],
      colunasMobile: [
        { key: "nm_nr_titulo", label: "Nº Título", sortable: true, size:'0.5fr' },
        { key: "nm_devedor", label: "Devedor", sortable: true, size:'2fr' },
        { key: "actions", label: "Ação", sortable: false, size:"0.5fr", acoes: [
        ]}
      ],
      fields: [
        { key: "cd_anuencia", label: "Nº Anuência ", sortable: false },
        { key: "nm_nr_titulo", label: "Nº Título", sortable: true },
        { key: "sg_especie", label: "Espécie", sortable: true },
        { key: "NomeCartorio", label: "Cartório", sortable: true },
        { key: "nm_devedor", label: "Devedor", sortable: true },
        { key: "documento_devedor", label: "Documento", sortable: true },
        { key: "dt_cadastro", label: "Cadastrado em", sortable: true },
        { key: "vl_titulo", label: "Valor Título", sortable: true },
        { key: "vl_protesto", label: "Valor Protestado", sortable: true },
        { key: "ds_status", label: "Status Solicitação", sortable: true },
        { key: 'Exibir', label: 'Exibir',sortable: false },
        { key: "actions", label: "Ação" },
      ],
      items: [],
      form:{},
      // form: {
      //   nomeDevedor: "",
      //   dtSolcitacao: "",
      //   nrtituloDevedor: "",
      //   docDevedor: "",
      // },
      empresaSelecionada: "",
      statusSelecionado: "",
      empresaCredora: [],
      statusSolicitacao: [],
      dadosDevedor: [],
      show: true,
      VempresaCredora: true,
      itemsSelecionados: [],
      erro: { msg: "", titulo: "" },
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    _dataMaxima() {
      return new Date().toLocaleDateString().split("/").reverse().join("-");
    },
  },
  created: function () {
    // this.pesquisar();
    this.informacoesCertificado();
    this.logged = true;
    this.empresaCredoraSelected = localStorage.getItem("usrCpf")
    this.loading = false;
  },
  filters: {
    moeda: function (value) {
      if (value) {
        return parseFloat(value).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        });
      }
      return "R$ 0,00";
    },
    dataHora: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          hour: "numeric",
          minute: "numeric",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    data: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    documento: function (entrada) {
      if (entrada) {
        let tamanho = entrada.toString().length,
          padraoCPF = /(\d{3})(\d{3})(\d{3})(\d{2})/,
          padraoCNPJ = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          subCPF = "$1.$2.$3-$4",
          subCNPJ = "$1.$2.$3/$4-$5";

        if (tamanho == 11) {
          return entrada.replace(padraoCPF, subCPF);
        } else if (tamanho == 14) {
          return entrada.replace(padraoCNPJ, subCNPJ);
        } else {
          return "";
        }
      }
      return "";
    },
    nomeCartorio: function (entrada) {
      if (entrada) {
        return entrada.split(" / ")[0];
      }
      return "";
    },
    cidadeCartorio: function (entrada) {
      if (entrada) {
        return entrada.split(" / ")[1];
      }
      return "";
    },
  },
  methods: {
    cancelar_pedido(row){
      alert
        this.cd_pedido_atual = row.cd_anuencia
        this.motivo_cancelamento = null
        this.mensagem = "Está ação é irreversível. <br><br> Deseja cancelar o Pedido: <b>" + this.cd_pedido_atual + "</b>"
        this.$refs['cancelar_pedido'].show();
      
    },
    fechar_modal(){
      this.$refs['cancelar_pedido'].hide();
    },
    efetua_cancelamento_pedido(){
      this.carregando = true
      const token = localStorage.getItem('jwtToken')
      let self = this
      API.post(`anuencia/cancelar_pedido`, { token: token, cd_pedido: this.cd_pedido_atual, motivo:this.motivo_cancelamento }).then(() => {
        self.cd_pedido_atual = null
        self.motivo_cancelamento = null
        self.mensagem = null
        self.carregando = false
        self.$refs['cancelar_pedido'].hide();
        self.pesquisar()

      });

    },
    filtrarBusca(filtros){
      this.form = {
        nomeDevedor: (filtros.nm_devedor !== null && filtros.nm_devedor !== undefined ? filtros.nm_devedor : ''),
        docDevedor: (filtros.nm_nr_identificacao_devedor !== null && filtros.nm_nr_identificacao_devedor !== undefined ? filtros.nm_nr_identificacao_devedor : ''),
        nrTituloDevedor: (filtros.nm_nr_titulo !== null && filtros.nm_nr_titulo !== undefined ? filtros.nm_nr_titulo : ''),
        dtSolicitacao: (filtros.dt_cadastro !== null && filtros.dt_cadastro !== undefined ? filtros.dt_cadastro : ''),
      };
      this.pesquisar();
    },
    executarFuncao: function(funcao, linha){
      if (this[funcao]){
        this[funcao](linha)
      }
    },
    informacoesCertificado() {
      const cpfCertificado = localStorage.getItem("usrCpf"),
        nomeCertificado = localStorage.getItem("usrName");

      this.empresaCredora.push({
        value: cpfCertificado,
        text: `${nomeCertificado} - ${cpfCertificado}`,
      });
    },
    async pesquisar() {
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      await API.post("anuencia/aprovadas", {
        ...this.form,
        token: token,
      })
        .then((res) => {
          this.items = res.data;
          this.loading = false;
          if (!res.data.length) {
            this.erro.msg =
              "Não foram encontrados resultados com os filtros fornecidos";
            this.erro.titulo = "Atenção";
            this.$refs.erro.show();
          }
        })
        .catch(() => {
          this.loading = false;

          this.erro.msg =
            "Não foi possível realizar a pesquisa, por favor, verifique se a sessão permanece ativa";
          this.erro.titulo = "Atenção";
          this.$refs.erro.show();
        });
    },
    baixarPDF: function (row) {
      let id = row.cd_anuencia
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      API.post("anuencia/pdfPedidoAnexo", {
        cd_anuencia_titulo: id,
        token,
      })
        .then((res) => {
            const base64String = res.data.dados.pdf; // your base64 string here
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'download_anuencia_' + id + '.pdf'; // the name of the file to download
            link.click();


          if (res.data.dados.pdf_anexo != null) {
            this.baixarAnexoPdf(id, res.data.dados.pdf_anexo);
          }
          this.loading = false;
        })
        .catch(() => {
          alert("Falha ao realizar o Download");
          this.loading = false;
        });
    },
    baixarAnexoPdf(id, anexo) {
      // let dwnldAnexo = document.getElementById("anexo");
      // dwnldAnexo.href = "data:application/pdf;base64," + anexo;
      // //setTimeout(function(){
      // dwnldAnexo.click();
      // }, 1000);

      const base64String = anexo; // your base64 string here
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'download_anexo_anuencia_' + id + '.pdf'; // the name of the file to download
      link.click();
    },
    resetarMsg() {
      this.erro.msg = "";
      this.erro.titulo = "";
    },
  },
};
</script>

<style scoped>
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}

#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  background-color: #ffffff;
  overflow-x: hidden;
    border-top: 1px solid #f1f1f1;
}

.lista-certidoes {
  color: #000;
}

.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

a {
  color: #555;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}

.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209cee;
  border-top: 5px solid #209cee;
  animation: loading 3s linear infinite;
}

.loading {
  position: absolute;
  color: #000;
  width: 100%;
  text-align: center;
}

@keyframes loading {
  100% {
    transform: rotate(360deg);
  }
}

.bold {
  font-weight: bold;
}

.mensagemErro {
  color: red;
}

#painel > .row{justify-content: space-between;}
#painel{scrollbar-width:none;}
#painel::-webkit-scrollbar{display:none;}
.espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
#painel h1 {text-align: left;font: normal normal bold 25px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 33px;}

#painelcontainerfluid{padding:0;padding-right: 3.8vw;margin-top: 37px;}
@media (max-width:1600px) and (min-width:1400px){
  .espaco-menu{margin-left: calc(20px - 5px) !important;}  
  #painelcontainerfluid{padding-right: 20px !important;}
}
@media (max-width:1399px) and (min-width:1200px){
  .espaco-menu{margin-left: calc(10px - 5px) !important;}
  #painelcontainerfluid{padding-right: 10px !important;}
}
@media (max-width:1199px){
  #painel {padding:0 17px;}
  #painel > .row{
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }
  .col-lg-9{max-width: none;flex: 1 1 100%;padding: 0;}
  #painel{padding:0px !important;}
  #painelcontainerfluid{padding:0px !important;}
}
.breadcrumb{margin-left: 0px;background: unset;}
.breadcrumb a, .breadcrumb span, .breadcrumb-item + .breadcrumb-item::before{font: normal normal 200 16px/20px 'Kanit', sans-serif;}
.breadcrumb-item + .breadcrumb-item::before{float:unset;}
.breadcrumb a{color: var(--primary-color);}
.breadcrumb-item + .breadcrumb-item::before{color: var(--primary-color);}
.breadcrumb span{color: var(--secondary-color);}
.breadcrumb a.disabled{text-decoration:none;cursor:default;}
.btn-voltar {display: flex;align-items: center;margin-left: auto;letter-spacing: 0px;text-decoration: none;justify-content: flex-end !important;margin-bottom: 20px;}
.btn-voltar img{width: 20px;height: 20px;margin-left: 6px;}

</style>
